function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M54.1 0C24.72 0 0.899995 13.94 0.919995 44.65C0.899995 75.36 24.72 89.3 54.09 89.3C83.45 89.3 107.27 75.36 107.26 44.65C107.27 13.94 83.45 0 54.09 0H54.1Z",
  fill: "#111927"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M78.48 43.8599H60.81C58.39 43.8599 56.23 42.4199 55.31 40.1799C54.38 37.9399 54.89 35.3999 56.6 33.6899L66.6 23.6899C68.43 24.7899 70.11 26.1099 71.58 27.6399L61.68 37.5499H77.44C78.05 39.5599 78.41 41.6799 78.48 43.8699V43.8599Z",
  fill: "#F2F2EF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M53.27 20.2598V37.8898C53.27 40.3098 51.83 42.4698 49.59 43.3998C48.85 43.7098 48.07 43.8498 47.3 43.8498C45.75 43.8498 44.24 43.2498 43.1 42.1098L33.13 32.1398C34.23 30.3098 35.56 28.6298 37.08 27.1598L46.95 37.0298V21.3198C48.96 20.7098 51.08 20.3398 53.27 20.2798V20.2598Z",
  fill: "#F2F2EF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M75.02 57.2C73.92 59.03 72.59 60.71 71.06 62.18L61.15 52.27V68.02C59.14 68.63 57.02 68.99 54.83 69.05V51.39C54.83 48.97 56.27 46.81 58.51 45.89C60.74 44.97 63.29 45.47 65 47.18L75.02 57.2Z",
  fill: "#F2F2EF"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M51.51 55.5899L41.52 65.5799C39.69 64.4799 38.02 63.1499 36.55 61.6199L46.43 51.7399H30.72C30.11 49.7299 29.75 47.6099 29.68 45.4199H47.29C49.71 45.4199 51.87 46.8599 52.79 49.0999C53.72 51.3299 53.21 53.8799 51.5 55.5899H51.51Z",
  fill: "#F2F2EF"
});

function SvgMisSymbol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 108 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMisSymbol);
export default __webpack_public_path__ + "static/media/mis-symbol.08328560.svg";
export { ForwardRef as ReactComponent };